import { render, staticRenderFns } from "./JourneyBuilderMenuArea.vue?vue&type=template&id=94a29e1a&scoped=true&"
import script from "./JourneyBuilderMenuArea.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderMenuArea.vue?vue&type=script&lang=js&"
import style0 from "../../Style/journey-builder-menu-brick-composer.scss?vue&type=style&index=0&id=94a29e1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a29e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94a29e1a')) {
      api.createRecord('94a29e1a', component.options)
    } else {
      api.reload('94a29e1a', component.options)
    }
    module.hot.accept("./JourneyBuilderMenuArea.vue?vue&type=template&id=94a29e1a&scoped=true&", function () {
      api.rerender('94a29e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Menu/JourneyBuilderMenuArea.vue"
export default component.exports